export default __webpack_public_path__ + "static/offering4-89725abc7751756a33bca7e607397b00.png";